import { BMPrimitives, BMText } from "@traveloka/district-bloom";
import { Image, Pressable, ScrollView, StyleSheet } from "react-native";
import { FLIGHT_ICON } from "../../../../assets/products/flight";
import { HOTEL_ICON } from "../../../../assets/products/hotel";
import BMView from "../../../../components/View/BMView";
import { useMobileContentResource } from "../../../../core/resource/MobileResourceProvider";
import RecentSearchFlightCard from "./RecentSearchFlightCard";
import RecentSearchHotelCard from "./RecentSearchHotelCard";

export type FlightData = {
  departureLocation: string;
  arrivalLocation: string;
  departureDate: Date;
  seatClass: string;
  isRoundTrip: boolean;
  arrivalImageUri?: string;
};

export type HotelData = {
  id: string;
  type: string;
  geoName: string;
  checkInDate: Date;
  checkOutDate: Date;
  hotelImageUri?: string;
};

type Props =
  | {
      productType: "FLIGHT";
      data: FlightData[];
      onPress: (data: FlightData, index: number) => void;
    }
  | {
      productType: "HOTEL";
      data: HotelData[];
      onPress: (data: HotelData, index: number) => void;
    };

export default function MobileHomeRecentSearch(props: Props) {
  const { productType, data } = props;

  const { CorporatePostLogin: cr } = useMobileContentResource();

  if (!data || data.length === 0) {
    return null;
  }

  // Placeholder for the icon and text based on product type
  let iconUri = "";
  let textContent = "";

  switch (productType) {
    case "FLIGHT":
      iconUri = FLIGHT_ICON;
      textContent = cr.recentFlightTitle;
      break;
    case "HOTEL":
      iconUri = HOTEL_ICON;
      textContent = cr.recentHotelTitle;
      break;
  }

  return (
    <BMView>
      <BMView style={styles.titleSection} row spacing="xs">
        <Image style={styles.icon} source={{ uri: iconUri }} />
        <BMText variant="uiHuge">{textContent}</BMText>
      </BMView>
      <ScrollView
        style={styles.contentSection}
        horizontal
        showsHorizontalScrollIndicator={false}
      >
        <BMView row spacing="md">
          {props.productType === "FLIGHT"
            ? props.data.slice(0, 3).map((item, index) => (
                <Pressable onPress={() => props.onPress(item, index)}>
                  <RecentSearchFlightCard data={item} />
                </Pressable>
              ))
            : props.data.slice(0, 3).map((item, index) => (
                <Pressable onPress={() => props.onPress(item, index)}>
                  <RecentSearchHotelCard data={item} />
                </Pressable>
              ))}
        </BMView>
      </ScrollView>
    </BMView>
  );
}

const styles = StyleSheet.create({
  titleSection: {
    paddingTop: BMPrimitives.BMSize.lg,
    paddingHorizontal: BMPrimitives.BMSize.md,
  },
  contentSection: {
    paddingHorizontal: BMPrimitives.BMSize.md,
    paddingTop: BMPrimitives.BMSize.lg,
    paddingBottom: BMPrimitives.BMSize.xl3,
  },
  icon: {
    width: 16,
    height: 16,
  },
});
